module.exports = __webpack_public_path__ + "static/img/theme-banner-title.a430bf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/theme-banner-title.png
// module id = TVAE
// module chunks = 1